import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "ActivityManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      activities: [],
      editIndex: null,
      editableRow: null,
      protocolId: "",
      idToken: "",
      pageindex: 1,
      pageSize: 10,
      SortProperty: "activityId",
      ConvertToNumeric :true,
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
      currentPage: 1,
      loadNextPage: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationErrors: {},
      isAddingNew: false,
      newRow: {
        activityId: "",
        activityName: "",
        activityType: "",
        description: "",
        notes: "",
        requiredForm: "",
        formRequired: true,
      },
      newRowErrors: {},

      protocol: {},
      expandedDescriptionIds: [],
      descriptionCharLimit: 150,
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;

    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.listActivities(this.protocolId);
    }
  },
  methods: {
    async listActivities(protocolId) {
      await axios
        .get(
          `${this.baseurl}/management/studyprotocol/listdaactivities?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.activities = res.data.results;
          this.totalCount = res.data.totalCount;
          this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
          this.expandedDescriptionIds = [];
        })
        .catch((err) => console.log("Error in fetching activities:", err));
    },
    isDescriptionExpanded(id) {
      return this.expandedDescriptionIds.includes(id);
    },
    toggleDescription(id) {
      const idx = this.expandedDescriptionIds.indexOf(id);
      if (idx === -1) {
        this.expandedDescriptionIds.push(id);
      } else {
        this.expandedDescriptionIds.splice(idx, 1);
      }
    },
    truncatedText(text) {
      if (!text) return "";
      return text.length > this.descriptionCharLimit
        ? text.slice(0, this.descriptionCharLimit) + "..."
        : text;
    },
    editRow(index, activity) {
      this.editIndex = index;
      this.editableRow = { ...activity };
      this.validationErrors = {};
    },
    validateRow() {
      this.validationErrors = {};
      if (!this.editableRow.activityId) {
        this.validationErrors.activityId = "Activity ID is required.";
      }
      if (!this.editableRow.activityName) {
        this.validationErrors.activityName = "Activity Name is required.";
      }

      return Object.keys(this.validationErrors).length === 0;
    },
    async updateRow(daActivityId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          daActivityId: daActivityId,
          protocolRefId: this.protocolId,
          studyId: this.protocol.studyId,
          activityId: this.editableRow.activityId,
          activityName: this.editableRow.activityName,
          activityType: this.editableRow.activityType,
          description: this.editableRow.description,
          notes: this.editableRow.notes,
          requiredForm: this.editableRow.requiredForm,
          formRequired: this.editableRow.formRequired,
        };

        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedaactivity`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        await this.getProtocolbyId();
        this.cancelEdit();
        await this.listActivities(this.protocolId);

        alert("Activity details updated successfully.");
      } catch (err) {
        console.error("Error during updateRow API call:", err);
        alert("Failed to update activity. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadNextPage = true;
      await this.listActivities(this.protocolId);
    },
    async deleteRow(activityId) {
      try {
        const confirmation = confirm("Are you sure you want to delete this activity?");
        if (!confirmation) return;

        const response = await axios.delete(
          `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_Activities&id=${activityId}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Delete response:", response.data);
        await this.listActivities(this.protocolId);
        if (this.activities.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
          await this.listActivities(this.protocolId);
        }
        alert("Activity deleted successfully.");
      } catch (error) {
        console.error("Error during activity delete API call:", error);
        alert("Failed to delete the activity. Please try again.");
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = {
        activityId: "",
        activityName: "",
        activityType: "",
        description: "",
        notes: "",
        requiredForm: "",
        formRequired: true,
      };
      this.newRowErrors = {};
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.activityId) {
        this.newRowErrors.activityId = "Activity ID is required.";
      }
      if (!this.newRow.activityName) {
        this.newRowErrors.activityName = "Activity Name is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_Activities",
          data: {
            protocolRefId: this.protocolId,
            studyId: this.protocol.studyId,
            activityId: this.newRow.activityId,
            activityName: this.newRow.activityName,
            activityType: this.newRow.activityType,
            description: this.newRow.description,
            notes: this.newRow.notes,
            requiredForm: this.newRow.requiredForm,
            formRequired: this.newRow.formRequired,
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};

        await this.listActivities(this.protocolId);

        alert("Activity created successfully.");
      } catch (err) {
        console.error("Error creating activity:", err);
        alert("Failed to create activity. Please try again.");
      }
    }
  },
};